// Core
import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';

import { editElement, changeDevice, setShowBlockSettings, setGlobalList } from './lib/core/redux/actions';
import { getStoreLogo } from './lib/core/redux/api/global';
import { fetchPages, changePage, savePage } from './lib/core/redux/api/pages';
import {
  fetchPayloads,
  setPayload,
  updatePayloadHistory,
  clearHistory,
  setHistorying,
} from './lib/core/redux/api/payloads';
import { fetchProducts } from './lib/core/redux/api/products';
import { fetchCategories } from './lib/core/redux/api/categories';
import { fetchMenu } from './lib/core/redux/api/menu';
import { fetchThemes, selectedTheme } from './lib/core/redux/api/themes';
import { fetchLangs, getTranslations } from './lib/core/redux/api/langs';
import { copyIt } from './lib/core/redux/actions';
import { fetchTemplates } from './lib/core/redux/api/templates';

import html2canvas from 'html2canvas';
import ReactJson from 'react-json-view';

import state from './lib/state';

// Components
import { PaletteSide, PaletteIcon, DefaultSection } from './lib/components/PaletteSide';
import { Canvas } from './lib/components/Core';
import BlockSettings from './lib/components/BlockSettings';
import SaveDialog from './lib/components/SaveDialog';
import SaveBlockDialog from './lib/components/SaveBlockDialog';
import HeaderFooter from './lib/components/HeaderFooter';
import MenuItems from './lib/components/MenuItems';
import Settings from './lib/components/Settings';
import PagesPalette from './lib/components/PagesPalette';
import ThemesPalette from './lib/components/ThemesPalette';
import ThemeAppearance from './lib/components/ThemeAppearance';
import PayloadsList from './lib/components/PayloadsList';

// Functions
import GKEvent from './lib/events';
import NotifBar from './lib/core/functions/NotifBar';
import { fetchAppearanceSettings } from './lib/functions';

// CSS
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './scss/App.scss';

// Images & Medias
import Icons from './lib/components/Icons';

// Font Awesome Start
import { library } from '@fortawesome/fontawesome-svg-core';
import * as myFaIcons from '@fortawesome/free-solid-svg-icons';
import * as myBrandsFaIcons from '@fortawesome/free-brands-svg-icons';

import {
  faCreditCardFront,
  faSlidersVSquare,
  faDollarSign,
  faLayerGroup,
  faPercent,
  faTruck,
  faWindowRestore,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faTimes,
  faText,
  faTrashAlt,
  faColumns,
  faChevronDown,
  faChevronUp,
  faArrows,
  faEye,
  faImage,
  faImages,
  faFolders,
  faShoppingBag,
  faStar as faStarEmpty,
  faUser,
  faPlayCircle,
  faTag,
  faExclamationTriangle,
  faCartPlus,
  faCommentSmile,
  faList,
  faShoppingBasket,
  faLink,
  faEnvelopeOpenText,
  faRectangleLandscape,
  faCheckSquare,
  faStepForward,
  faShoppingCart,
  faIcons,
  faCode,
  faCopy,
} from '@fortawesome/pro-light-svg-icons';
import { inArray, l, inlinePayload, getSpecificElementsUncategorised, getPayload, getParams } from './lib/functions';
import { ajaxUri } from './lib/consts/index';
import UndoRedo from './lib/components/UndoRedo';
import LangSwitcher from './lib/components/LangSwitcher';
import { resetId } from './lib/functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Tour from 'reactour';
import AdminSaveDialog from './lib/components/AdminSaveDialog';
import AddNewPalette from './lib/components/AddNewPalette';
import FloatElementSettings from './lib/components/FloatElementSettings';
import SidePalette from './lib/components/SidePalette';
import PageSettings from './lib/components/PageSettings';

const iconList = Object.keys(myFaIcons)
  .filter((key) => key !== 'fas' && key !== 'prefix')
  .map((icon) => myFaIcons[icon]);
const iconBrandsList = Object.keys(myBrandsFaIcons)
  .filter((key) => key !== 'fab' && key !== 'prefix')
  .map((icon) => myBrandsFaIcons[icon]);

library.add(
  faTimes,
  faCode,
  faWindowRestore,
  faPercent,
  faIcons,
  faTruck,
  faStepForward,
  faLayerGroup,
  faCheckSquare,
  faRectangleLandscape,
  faEnvelopeOpenText,
  faLink,
  faText,
  faTrashAlt,
  faColumns,
  faChevronDown,
  faChevronUp,
  faArrows,
  faEye,
  faImage,
  faImages,
  faFolders,
  faShoppingBag,
  faStarEmpty,
  faUser,
  faPlayCircle,
  faTag,
  faExclamationTriangle,
  faCartPlus,
  faCreditCardFront,
  faSlidersVSquare,
  faCommentSmile,
  faList,
  faDollarSign,
  faShoppingBasket,
  faShoppingCart,
  faCopy
);

library.add(...iconList);
library.add(...iconBrandsList);

const Loader = ({ color }) => {
  return (
    <div className={`gp-loader color-${color || 1}`}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' className={`groove-logo speed-${color || 1}`}>
        <path d='M19.722 19.852h19.326c-.829 8.975-4.942 14.896-12.34 17.763-7.397 2.866-14.386 1.433-20.966-4.3l6.906-6.626c2.51 1.84 4.869 2.76 7.074 2.76 2.206 0 4.268-.844 6.186-2.532l-6.186-7.065zM0 19.36h9.909c.391-4.854 2.702-7.9 6.933-9.137 4.23-1.236 7.798.038 10.702 3.822l7.73-6.309C28.764.456 21.24-1.686 12.701 1.312 4.814 4.08.581 10.097 0 19.36z'></path>
      </svg>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    elementToEdit: state.rootReducer.elementToEdit || null,
    fetchedPages: state.rootReducer.fetchedPages || [],
    pageLoading: state.rootReducer.pageLoading || 0,
    elementOptions: state.rootReducer.elementOptions || [],
    palettes: state.rootReducer.palettes || [],
    currentPage: state.rootReducer.currentPage || 'home',
    savedPage: state.rootReducer.savedPage,
    saveAlert: state.rootReducer.saveAlert || null,

    previousPayload:
      (state.undo.past[state.undo.index - 1] && state.undo.past[state.undo.index - 1].currentPayload) || null,
    currentPayload: state.undo.present.currentPayload || [],
    nextPayload: (state.undo.future[0] && state.undo.future[0].currentPayload) || null,
    historying: state.rootReducer.historying || false,
    undo: state.undp || false,

    currentDevice: state.rootReducer.currentDevice || 'xl',
    toCopy: state.rootReducer.toCopy || null,
    blockToCopy: state.rootReducer.blockToCopy || null,
    showBlockSettings: state.rootReducer.showBlockSettings ?? false,
    showSideBar: state.rootReducer.showSideBar ?? true,
    currentSettingsTab: state.rootReducer.currentSettingsTab || 1,
    openFloatElementSettings: state.rootReducer.openFloatElementSettings ?? false,
  };
};

const getPageName = (fetchedPages, currentPage) => {
  let pagename = '...';

  const dynamicZones = [
    {
      key: 'top_bar',
      name: l('Top Bar'),
    },
    {
      key: 'header',
      name: l('Header'),
    },
    {
      key: 'footer',
      name: l('Footer'),
    },
    {
      key: 'flyoutcart',
      name: l('Flyout Cart'),
    },
  ];

  const loopPages = [...dynamicZones, ...fetchedPages];

  loopPages.forEach((page) => {
    if (page.key === currentPage) pagename = page.name;
  });

  return pagename;
};

const resizebase64 = (base64, maxWidth, maxHeight) => {
  return new Promise((resolve, reject) => {
    var img = new Image();

    img.onload = function () {
      if (typeof maxWidth === 'undefined') maxWidth = 500;
      if (typeof maxHeight === 'undefined') maxHeight = 500;

      // Create and initialize two canvas
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var canvasCopy = document.createElement('canvas');
      var copyContext = canvasCopy.getContext('2d');

      // Determine new ratio based on max size
      var ratio = 1;
      if (img.width > maxWidth) ratio = maxWidth / img.width;
      else if (img.height > maxHeight) ratio = maxHeight / img.height;

      // Draw original image in second canvas
      canvasCopy.width = img.width;
      canvasCopy.height = img.height;
      copyContext.drawImage(img, 0, 0);

      // Copy and resize second canvas to first canvas
      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;

      ctx.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height);

      resolve(canvas.toDataURL());
    };

    img.onerror = reject;

    img.src = base64;
  });
};

class App extends Component {
  constructor(props) {
    super(props);
    this.newUser = window.location.href.includes('welcome') ? true : false;

    this.state = {
      activeTab: 1,
      currentPalette: null,
      currentState: [],
      initialElements: [],
      notifBar: [],
      savingScreenshot: false,
      pageBackground: {},
      changingPayload: true,
      rightDropdown: false,
      currentTab: 1,
      frameVersion: 1,
      importLayout: false,
      showTour: this.newUser ? true : false,
      showFlyoutCart: false,
      headerSetting: true,
      showAdminSave: false,
      devices: false,
      showProductLayoutMessge: false,
      showProductLayoutWarning: false,
      homeProductID: null,
      homeProductLayout: null,
      showWarning: true,
      deprecatedElements: [],
    };
    this.saveTimer = null;
    this.devMode = window.location.href.includes('devgk') ? true : false;
    this.historyTracking = null;
    this.guideSteps = [
      {
        selector: '[data-step="1"]',
        content: l('This displays the name of the page you are currently editing.'),
      },
      {
        selector: '[data-step="2"]',
        content: l('Click on this button to go to GrooveKart Dashboard.'),
        observe: '[data-step-observe="2"]',
        action: () => {
          if (this.state.currentPalette) {
            setTimeout(() => {
              this.setState({ currentPalette: null });
            }, 500);
          }
        },
      },
      {
        selector: '[data-step="addnew"]',
        content: l('Click here for predesigned blocks/elements you can drag and drop into your page.'),
      },

      {
        selector: '[data-step="pages"]',
        content: ({ goTo, inDOM }) => (
          <div>
            {this.state.currentPalette !== 'pages' ? (
              l('Click the Pages tab to see all of your store pages.')
            ) : (
              <div>
                <p>
                  {l("In this section you'll find two tabs.")} <strong>{l('Navigation')}</strong> &amp;{' '}
                  <strong>{l('Pages')}</strong>.
                </p>
                <p>
                  {l(
                    "Under <strong>Navigation</strong> you'll find all of the features that allow you to add, configure and modify the appearance and function of your store navigation menu."
                  )}
                </p>
                <p>
                  {l(
                    "Under <strong>Pages</strong> you'll see a list of all of your store pages. You can add custom pages by clicking on the (+) icon at the top."
                  )}
                </p>
              </div>
            )}
          </div>
        ),
        // observe: '[data-step-observe="left-side-pages"]',
        action: () => {
          if (this.state.currentPalette === 'elements' || this.state.currentPalette === 'settings') {
            setTimeout(() => {
              this.setState({ currentPalette: null });
            }, 500);
          }
        },
      },
      {
        selector: '[data-step="themes"]',
        content: l('Click here to set the overall settings for the design and customer experience in your store.'),
        // observe: '[data-step-observe="left-side-themes"]',
        action: () => {
          if (this.state.currentPalette === 'pages') {
            setTimeout(() => {
              this.setState({ currentPalette: null });
            }, 500);
          }
        },
      },
      {
        selector: '[data-step="pageSettings"]',
        content: l('Click here to change the SEO settings for the page.'),
        // observe: '[data-step-observe="left-side-themes"]',
        action: () => {
          if (this.state.currentPalette === 'pages') {
            setTimeout(() => {
              this.setState({ currentPalette: null });
            }, 500);
          }
        },
      },
      {
        selector: '[data-step="3"]',
        content: l('Drag and Drop blocks or elements onto this canvas to begin building your store page'),
        action: () => {
          if (this.state.currentPalette === 'settings') {
            setTimeout(() => {
              this.setState({ currentPalette: null });
            }, 500);
          }
        },
      },
      {
        selector: '[data-step="goback"]',
        content: l('Click to go to previous page.'),
      },
      {
        selector: '[data-step="4"]',
        content: l('To see how your store page looks on different devices, click these icons.'),
      },
      {
        selector: '[data-step="5"]',
        content: l('Congratulations! You completed the tour. To start it over please click here.'),
      },
    ];

    // register all palette elements
    this._setPalette = this._setPalette.bind(this);

    // state.clearState() triggers this event
    state.addEventListener('flush', (e) => this.props.editElement(null));

    // state.removeElement() triggers this event
    state.addEventListener('removeElement', (e) => this.props.editElement(null));

    GKEvent.addEventListener('notification', (variant, message) => {
      const id = Math.floor(Math.random() * 1000);
      const notification = {
        open: true,
        variant: variant,
        message: message,
        id: id,
        closeBar: () => {
          this.setState({
            notifBar: [...this.state.notifBar.filter((item) => item.id !== id)],
          });
        },
      };

      this.setState({ notifBar: [...this.state.notifBar, notification] });
    });

    GKEvent.addEventListener('updatePageSetting', (background) => {
      this.setState({
        pageBackground: {
          backgroundColor: (background && background.backgroundColor) || null,
          backgroundImage: background && background.backgroundImage ? `url(${background.backgroundImage})` : null,
          backgroundSize: (background && background.backgroundSize) || null,
          backgroundRepeat: (background && background.backgroundRepeat) || null,
          backgroundPosition: (background && background.backgroundPosition) || null,
        },
      });
    });

    GKEvent.addEventListener('importLayout', (background) => {
      this.setState({
        importLayout: true,
      });
    });
  }

  componentWillMount() {
    state.addEventListener('change', this._stateChange);
  }

  componentDidMount() {
    this.props.getStoreLogo(10);
    this.props.fetchPages(10);
    this.props.fetchPayloads(10, ['top_bar', 'footer', 'flyoutcart']);
    this.props.fetchProducts(10);
    this.props.fetchCategories(20); // Must be double
    this.props.fetchMenu(10);
    this.props.fetchThemes(10);
    this.props.fetchTemplates(10);
    this.props.fetchLangs(10);
    fetchAppearanceSettings();
    this.props.selectedTheme();
    this._setGlobalList();

    //auto save
    const events = ['mousedown'];
    events.map((e) => {
      window.addEventListener(e, (ev) => {
        clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => {
          if (!this.props.savedPage) this._savedPage();
        }, 180000);
      });
    });
    this._getHomePageProductLayout();
  }

  _setGlobalList = () => {
    axios
      .post(ajaxUri, { request: 'getSetting', key: 'PS_CATEGORY_GLOBAL_SETTING' })
      .then((res) => {
        if (res.data) {
          this.props.setGlobalList(true);
        } else {
          this.props.setGlobalList(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  _getHomePageProductLayout = () => {
    axios
      .post(ajaxUri, {
        request: 'getProductAsHomePage',
      })
      .then((res) => {
        const { data } = res;
        const { product_id: productID, status, payload_id: layoutID } = data;

        if (productID && layoutID) {
          this.setState({
            showProductLayoutMessge: true,
            homeProductID: productID,
            homeProductLayout: layoutID,
          });
        } else {
          this.setState({ showProductLayoutWarning: false });
        }
      });
  };

  loadSeparately = () => {
    setTimeout(() => {
      this.props.fetchProducts(10);
    }, 3000);
  };

  componentWillReceiveProps({ pageLoading, currentPage, currentPayload, historying, toCopy, showSideBar }) {
    if (pageLoading != 0 && pageLoading > this.props.pageLoading) {
      if (pageLoading >= 100) {
        const frameVersion = this.state.frameVersion + 1;
        if (getParams('target')) {
          this.props.changePage(getParams('target'));
        } else {
          getPayload('home')
            .then((data) => {
              this.setState(
                {
                  initialElements: data,
                  frameVersion: frameVersion,
                  changingPayload: false,
                },
                () => {
                  this._updateHistory(data);
                  this.props.clearHistory();
                }
              );
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    }

    if (currentPage !== null && currentPage !== this.props.currentPage) {
      const windowContent = document.querySelector('.window-content');
      if (windowContent) windowContent.scrollTop = 0;
      this.setState({ changingPayload: true });
      this.props.savePage();
      const frameVersion = this.state.frameVersion + 1;

      if (currentPage === 'home') {
        if (this.state.homeProductID && this.state.homeProductLayout && !this.state.showProductLayoutMessge) {
          this.setState({
            showProductLayoutMessge: true,
          });
        }
      } else {
        this.setState({
          showProductLayoutMessge: null,
          showProductLayoutWarning: null,
        });
      }

      getPayload(currentPage).then((data) => {
        const st = JSON.stringify(data);

        if (st.indexOf('product_instant_checkout') != -1) {
          if (st.indexOf('product_add_to_cart') != -1) {
            GKEvent.notification('error', 'Instant checkout error');
          }
        } else if (st.indexOf('product_instant_checkout') != -1) {
          if (st.indexOf('product_add_to_cart') != -1) {
            GKEvent.notification('error', 'Instant checkout error');
          }
        }

        this.setState(
          {
            initialElements: data,
            frameVersion: frameVersion,
            changingPayload: false,
          },
          () => {
            this._updateHistory(data);
            this.props.clearHistory();
            this.props.editElement(null);
          }
        );
      });
    }

    if (JSON.stringify(this.props.currentPayload) !== JSON.stringify(currentPayload) && historying) {
      this.setState(
        {
          initialElements: currentPayload,
          frameVersion: Math.random(),
        },
        () => {
          this.props.setHistorying(false);
        }
      );
    }

    if (this.props.toCopy !== toCopy) {
      if (toCopy) this.setState({ currentPalette: 'pages' });
      else {
        if (this.props.toCopy !== null) this.setState({ currentPalette: null });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.elementToEdit === 'appearance' || this.props.elementToEdit === 'header') {
      this.props.setShowBlockSettings(false);
    }
    if (
      this.props.elementToEdit &&
      this.state.currentPalette &&
      (this.state.currentPalette != 'themes' ||
        (this.props.elementToEdit !== 'appearance' && this.props.elementToEdit !== 'header')) &&
      this.props.toCopy == null
    ) {
      this.setState({ currentPalette: null });
    }
    if (
      prevState.currentPalette !== this.state.currentPalette &&
      this.props.toCopy !== null &&
      this.state.currentPalette !== 'pages'
    ) {
      this.props.copyIt(null);
    }
  }

  _stateChange = (s) => {
    const newState = state.getStorableState();
    this.setState({ currentState: newState });

    clearTimeout(this.historyTracking);

    this.historyTracking = setTimeout(() => {
      if (!this.state.changingPayload) {
        if (JSON.stringify(newState) !== JSON.stringify(this.state.initialElements)) {
          this.props.savePage(false);
          if (
            JSON.stringify(newState) !== JSON.stringify(this.props.previousPayload) &&
            JSON.stringify(newState) !== JSON.stringify(this.props.nextPayload)
          ) {
            this.setState({ initialElements: newState });
            this._updateHistory();
          }
        }
      }
    }, 200);
  };

  _updateHistory = (payload = state.getStorableState()) => {
    this.props.updatePayloadHistory(payload);
  };

  _onDrop = (data, cb) => {
    // no need to ask id and name again
    if (data.payload && data.payload.dropped) return cb(data);

    if (data.type === 'block') {
      let blocks = [];
      data.options.content.forEach((content) => {
        blocks.push(resetId(content));
      });
      cb(blocks);
    } else {
      const id = 'gk-' + Math.floor(Math.random() * 10000 + 1);
      let name = data.name;

      cb({
        ...data,
        name,
        id,
        elementId: data.id,
        payload: {
          dropped: true,
          ...this.props.elementOptions[data.id].payload,
        },
      });
    }
  };

  _setPalette = (paletteId) => {
    this.props.editElement(null);
    this.setState({
      currentPalette: paletteId,
    });
  };

  _getPageBackground = (pageid) => {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'getPageSettings',
        pageid: pageid,
      },
    })
      .then((result) => {
        if (result.data.datas && result.data.datas.background) {
          const { background } = result.data.datas;

          this.setState({
            pageBackground: {
              backgroundColor: (background && background.backgroundColor) || null,
              backgroundImage: background && background.backgroundImage ? `url(${background.backgroundImage})` : null,
              backgroundSize: (background && background.backgroundSize) || null,
              backgroundRepeat: (background && background.backgroundRepeat) || null,
              backgroundPosition: (background && background.backgroundPosition) || null,
            },
          });
        } else
          this.setState({
            pageBackground: {},
          });
      })
      .catch((error) => {});
  };

  _savedPage = async (name = null, type = null, cb = () => {}) => {
    this.setState({ changingPayload: true });
    let img = '';
    if (this.props.currentPage.includes('product_') || this.props.currentPage.includes('upsell_')) {
      img = await this._screenShot();
    }


    // this._screenShot().then((img) => {
    this._saveLayout(img, name, type)
      .then((result) => {
        GKEvent.notification(result?.data?.status, result?.data?.message);
        this.setState({
          changingPayload: false,
          initialElements: state.getStorableState(),
        });

        this.props.savePage();
        cb();
      })
      .catch((err) => {
        console.log(err);
        if (err === 'insent_checkout_error')
          GKEvent.notification('warning', 'Instant checkout can not be used with add to cart element together.');
        else {
          GKEvent.notification('warning', err);
        }
        this.setState({
          changingPayload: false,
          initialElements: state.getStorableState(),
        });
        cb();
      });
    // });
  };
  _saveLayout = async (screenShot = '', name = '', type = '') => {
    const payload = state.getStorableState();

    const st = JSON.stringify(payload);
    if (st.indexOf('product_instant_checkout') != -1) {
      if (st.indexOf('product_add_to_cart') != -1) {
        return new Promise((resolve, reject) => {
          reject('insent_checkout_error');
        });
      }
    } else if (st.indexOf('product_instant_checkout') != -1) {
      if (st.indexOf('product_add_to_cart') != -1) {
        return new Promise((resolve, reject) => {
          reject('insent_checkout_error');
        });
      }
    }

    this.props.editElement(null);

    const requiredElementsGroup = {
      category: ['category_title', 'category_products'],
      checkout: ['checkout_summary', 'checkout_form'],
      shoppingcart: ['summary'],
      product: ['product_pictures', 'product_title', 'product_attributes', 'product_pricing'],
      upsell: [
        'upsell_product_title',
        'upsell_product_pictures',
        'upsell_product_pricing',
        'upsell_product_attributes',
        'upsell_add_to_cart',
        'upsell_nothankyou',
      ],
    };

    const deprecatedElementsGroup = {
      checkout: ['checkout_steps'],
    };

    let index;
    let missingElements = '0';

    if (this.props.currentPage.includes('product_')) index = 'product';
    else if (this.props.currentPage.includes('upsell_')) index = 'upsell';
    else index = this.props.currentPage;

    var list = [];

    if (requiredElementsGroup[index] !== undefined) {
      const elements = inlinePayload(state.getStorableState());

      requiredElementsGroup[index].forEach((element) => {
        if (!inArray(element, elements)) {
          missingElements = '1';
          return;
        }
      });
    }
    let deprecatedElements = 0;

    if (deprecatedElementsGroup[index] !== undefined) {
      const elements = inlinePayload(state.getStorableState());
      deprecatedElementsGroup[index].forEach((element) => {
        if (inArray(element, elements)) {
          list.push(element.replace('_', ' '));
          deprecatedElements += 1;
        }
      });
    }

    if (deprecatedElements > 0) {
      return new Promise((resolve, reject) => {
        reject(`Page contains deprecated elemets [${list}], Please remove before saving.`);
      });
    }
    const fetchedPages = this.props.fetchedPages || [];
    const currentPage = this.props.currentPage || '';
    let meta_name = '';

    fetchedPages.map((item, index) => {
      if (item?.key == currentPage) {
        meta_name = item?.name;
      }
    });

    try {
      const result_1 = await axios({
        method: 'post',
        url: ajaxUri,
        data: {
          request: 'insert',
          target: 'payload',
          pageid: name ? null : this.props.currentPage,
          payload: payload,
          missing_element: missingElements,
          screen_shot: screenShot,
          name: name ? name : meta_name,
          type: type,
        },
      });
      this.props.fetchPages();
      if (
        this.props.currentPage === 'top_bar' ||
        this.props.currentPage === 'footer' ||
        this.props.currentPage === 'flyoutcart'
      )
        this.props.setPayload(this.props.currentPage, state.getStorableState());
      return result_1;
    } catch (error) {
      return [];
    }
  };

  _screenShot = () => {
    return new Promise((resolve, reject) => {
      let screenShot;
      document.querySelector('.window-content').scrollTop = 0;
      this.setState(
        {
          savingScreenshot: true,
        },
        () => {
          html2canvas(document.querySelector('.screenme'), {
            height: 1000,
            useCORS: false,
          }).then((canvas) => {
            this.setState({ savingScreenshot: false });
            screenShot = canvas.toDataURL();
            const minifiedScreenshot = resizebase64(screenShot, 1000, 1000);
            resolve(minifiedScreenshot);
          });
        }
      );
    });
  };

  _showRightTab = (id, tab) => {
    this.setState({
      rightDropdown: !this.state.rightDropdown,
      currentPalette: id,
      currentTab: tab,
    });
  };
  _showAppearance = (id, tab) => {
    this.props.editElement('appearance');
  };

  _breadcrumbGenerator = () => {
    let elements = [];
    if (this.props.elementToEdit) {
      const element = this.props.elementToEdit;

      for (const item of state.getTree(element.id).reverse()) {
        elements.push(
          <span
            key={item.id + '-' + Math.random()}
            className={element.id === item.id ? 'active' : ''}
            onClick={() => {
              this.props.editElement(state.getFullElement(item.id, item.dropzoneID, item.parentID));
            }}
          >
            {item.name}
          </span>
        );
        elements.push(<FontAwesomeIcon key={item.id + '-2' + Math.random()} icon={['fa', 'chevron-right']} />);
      }
    }
    return elements;
  };

  _specificElementExists = (json) => {
    if (json) {
      let layoutTypes = inlinePayload(json);

      for (const layoutType of layoutTypes) {
        if (inArray(layoutType, getSpecificElementsUncategorised())) {
          return true;
        }
      }
    }

    return false;
  };

  _clearCanvas = () => {
    const frameVersion = this.state.frameVersion + 1;

    this.setState(
      {
        initialElements: [],
        frameVersion: frameVersion,
      },
      () => {
        this._updateHistory([]);
        this.props.editElement(null);
        this.props.savePage(false);
      }
    );
  };

  _goToAdmin = () => {
    if (!this.props.savedPage) {
      this.setState({ showAdminSave: true });
    } else {
      window.open('/administration/', '_self');
    }
  };

  render() {
    return (
      <div className={`app ${this.state.savingScreenshot ? 'screenshoting' : ''}`}>
        {/* <button onClick={this.addN}>add</button> */}
        <AdminSaveDialog
          show={this.state.showAdminSave}
          onCancel={() => {
            window.open('/administration/', '_self');
          }}
          onConfirm={() => {
            this.props.savePage();
            window.open('/administration/', '_self');
          }}
          onClose={() => {
            this.setState({ showAdminSave: false });
          }}
        />
        <SaveDialog
          open={this.props.saveAlert !== null ? true : false}
          confirm={() => {
            this._savedPage(null, null, () => {
              this.props.changePage(this.props.saveAlert);
            });
          }}
          deny={() => {
            this.props.changePage(this.props.saveAlert);
          }}
        />
        <SaveBlockDialog
          error={
            this.props.blockToCopy && this._specificElementExists([this.props.blockToCopy.json])
              ? l('You are not allowed to save this layout because it contains specific page elements.')
              : null
          }
        />

        <NotifBar settings={this.state.notifBar} />

        <div className='app-container'>
          <div className='left-side'>
            <div className='element-group' style={this.state.changingPayload ? { pointerEvents: 'none' } : {}}>
              <div className='palette-icon-group'>
                {this.props.palettes.map((palette, index) => {
                  if (palette.id === 'blocks' || palette.id === 'elements') return <></>;
                  return (
                    <PaletteIcon
                      key={index}
                      title={palette.title}
                      icon={palette.icon}
                      paletteId={palette.id}
                      currentPaletteId={this.state.currentPalette}
                      onClick={this._setPalette}
                      custom={palette.custom || false}
                    />
                  );
                })}
              </div>

              <div className='icon information' onClick={() => this.setState({ showTour: true })} data-step='5'>
                <Icons icon='information' />
              </div>
            </div>

            {this.props.showSideBar && (
              <>
                <div className='side-elements' style={this.state.changingPayload ? { pointerEvents: 'none' } : {}}>
                  {this.state.currentPalette === 'addnew' && (
                    <>
                      <AddNewPalette
                        closeEvent={() => this.setState({ currentPalette: null })}
                        palettes={this.props.palettes}
                        currentPage={this.props.currentPage}
                      />
                    </>
                  )}
                  {this.state.currentPalette === 'pageSettings' && (
                    <PageSettings
                      onClose={() => this.setState({ currentPalette: null })}
                      currentPage={this.props.currentPage}
                    />
                  )}

                  {this.props.palettes.map((palette, index) => {
                    if (palette.id == 'addnew' || palette.id === 'pageSettings') return <></>;
                    return (
                      <>
                        <SidePalette
                          palette={palette}
                          currentPalette={this.state.currentPalette}
                          closeEvent={() => {
                            this.setState({ currentPalette: null });
                          }}
                          currentPage={this.props.currentPage}
                          copyIt={this.props.copyIt}
                          showCustomize={() => this._showAppearance('appearance', 2)}
                        />
                        {/*<PaletteSide
                        key={index}
                        title={palette.sideTitle}
                        paletteId={palette.id}
                        currentPaletteId={this.state.currentPalette}
                        closeEvent={() => {
                          this.setState({ currentPalette: null });
                        }}
                      >
                        
                        {palette.id === "pages" && (
                          <DefaultSection>
                            <PagesPalette
                              currentPage={this.props.currentPage}
                            />
                          </DefaultSection>
                        )}
                        {palette.id === "modal" && (
                          <DefaultSection>
                            <div className="palette-tab">
                              <ul className="tab-body">
                                <li>
                                  <PayloadsList
                                    target="modal"
                                    currentPage={this.props.currentPage}
                                  />
                                </li>
                              </ul>
                            </div>
                          </DefaultSection>
                        )}
                        {palette.id === "menu" && (
                          <DefaultSection
                            title={l(
                              "Menu items, click to edit or drag to change order"
                            )}
                          >
                            <MenuItems />
                          </DefaultSection>
                        )}
                        {palette.id === "settings" && (
                          <DefaultSection>
                            <Settings />
                          </DefaultSection>
                        )}
                        {palette.id === "themes" && (
                          <DefaultSection>
                            <ThemesPalette
                              currentTab={this.state.currentTab}
                              showCustomize={() =>
                                this._showAppearance("appearance", 2)
                              }
                            />
                          </DefaultSection>
                        )} 
                      </PaletteSide>*/}{' '}
                      </>
                    );
                  })}
                </div>
              </>
            )}
          </div>
          <div className='app-right'>
            <div className='top-area'>
              <div className='logo-area'>
                <a href='/administration/'>
                  {/* <img src={logo} alt="logo" /> */}
                  <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'>
                    <path
                      fill='#52A728'
                      d='M25.669 9.177H7.678c-.613 0-1.094.544-.998 1.135l1.563 10.253c.072.485.492.84.997.84h14.854c.493 0 .926-.355.998-.84l1.562-10.253c.096-.591-.372-1.135-.985-1.135z'
                    ></path>
                    <path
                      fill='#A8D393'
                      d='M10.381 26.667c1.148 0 2.08-.916 2.08-2.046s-.932-2.046-2.08-2.046c-1.148 0-2.079.916-2.079 2.046s.93 2.046 2.08 2.046zM23.11 26.667c1.147 0 2.078-.916 2.078-2.046s-.93-2.046-2.079-2.046c-1.148 0-2.079.916-2.079 2.046s.93 2.046 2.08 2.046zM11.067 7.024H4.853c-.468 0-.853-.378-.853-.84 0-.46.385-.85.865-.85h6.214c.468 0 .853.378.853.839 0 .461-.385.851-.865.851z'
                    ></path>
                  </svg>
                </a>
              </div>
              <div className='editing-area'>
                <p className='pagename' data-step='1'>
                  {/* add a go back functionality */}
                  <button
                    disabled={this.state.changingPayload}
                    onClick={() => {
                      this.props.changePage(null, 'back');
                    }}
                    data-step='goback'
                  >
                    <Icons icon={'angle-left'} />
                  </button>
                  {/* {l("You are editing")}{" "} */}
                  <span>{getPageName(this.props.fetchedPages, this.props.currentPage)}</span>
                </p>
              </div>
              <div className='middle-area'>
                {this.props.currentPage !== 'flyoutcart' && (
                  <ul className='inline-options small responsive-icons' data-step='4'>
                    <li
                      className={this.props.currentDevice === 'xs' ? 'selected' : ''}
                      onClick={() => {
                        this.props.changeDevice('xs');
                        this.setState({ devices: false });
                      }}
                    >
                      <Icons icon='xs-device' />
                    </li>
                    <li
                      className={this.props.currentDevice === 'sm' ? 'selected' : ''}
                      onClick={() => {
                        this.props.changeDevice('sm');
                        this.setState({ devices: false });
                      }}
                    >
                      <Icons icon='sm-device' />
                    </li>
                    <li
                      className={'selected'}
                      onClick={() => {
                        this.props.changeDevice('md');
                      }}
                      style={{
                        display: `${this.props.currentDevice === 'md' ? 'block' : 'none'}`,
                      }}
                    >
                      <Icons icon='md-device' />
                    </li>
                    <li
                      className={'selected'}
                      onClick={() => {
                        this.props.changeDevice('lg');
                      }}
                      style={{
                        display: `${this.props.currentDevice === 'lg' ? 'block' : 'none'}`,
                      }}
                    >
                      <Icons icon='lg-device' />
                    </li>
                    <li
                      className={this.props.currentDevice === 'xl' ? 'selected' : ''}
                      onClick={() => {
                        this.props.changeDevice('xl');
                        this.setState({ devices: false });
                      }}
                    >
                      <Icons icon='xl-device' />
                    </li>

                    {!this.state.devices && (
                      <li
                        onClick={() => {
                          this.setState({ devices: true });
                        }}
                        className='dots'
                      >
                        <Icons icon='dots' />
                      </li>
                    )}
                    {this.state.devices && (
                      <>
                        <li
                          className={this.props.currentDevice === 'md' ? 'selected' : ''}
                          onClick={() => {
                            this.props.changeDevice('md');
                            this.setState({ devices: false });
                          }}
                          style={{
                            display: `${this.props.currentDevice !== 'md' ? 'block' : 'none'}`,
                          }}
                        >
                          <Icons icon='md-device' />
                        </li>
                        <li
                          className={this.props.currentDevice === 'lg' ? 'selected' : ''}
                          onClick={() => {
                            this.props.changeDevice('lg');
                            this.setState({ devices: false });
                          }}
                          style={{
                            display: `${this.props.currentDevice !== 'lg' ? 'block' : 'none'}`,
                          }}
                        >
                          <Icons icon='lg-device' />
                        </li>
                        <li
                          onClick={() => {
                            this.setState({ devices: false });
                          }}
                        >
                          <Icons icon='time' />
                        </li>
                      </>
                    )}
                  </ul>
                )}
              </div>
              <div className='save-area' style={this.state.changingPayload ? { pointerEvents: 'none' } : {}}>
                <UndoRedo />
                {/* <LangSwitcher /> */}
                <button
                  disabled={this.props.savedPage || this.state.changingPayload}
                  onClick={() => {
                    this._savedPage();
                  }}
                  className='gk-button gk-small gk-primary gk-default'
                >
                  <span>
                    {(this.state.changingPayload && l('Please wait...')) ||
                      (this.props.savedPage && l('Saved')) ||
                      l('Save')}
                  </span>
                </button>
                {this.devMode && (
                  <button
                    onClick={() => {
                      this.setState({
                        activeTab: this.state.activeTab === 1 ? 3 : 1,
                      });
                    }}
                    className='gk-button gk-small gk-primary gk-default'
                  >
                    <span>{this.state.activeTab === 1 ? l('Show') : l('Hide')} Json</span>
                  </button>
                )}
                {this.devMode && (
                  <button onClick={() => this._clearCanvas()} className='gk-button gk-small gk-primary gk-default'>
                    <span>Clear canvas</span>
                  </button>
                )}
              </div>
              <div className='right-trigger' data-step-observe='2'>
                <a
                  // href="/administration/"
                  data-step='2'
                  className={'administration'}
                  onClick={this._goToAdmin}
                >
                  <Icons icon='administration' />
                </a>
              </div>
            </div>
            {(this.props.pageLoading < 100 && (
              <div className='bottom-area'>
                <Loader />
              </div>
            )) || (
              <div className='bottom-area'>
                {(this.state.showProductLayoutMessge || this.state.showProductLayoutWarning) && (
                  <div className='product-layout-message'>
                    {this.state.showProductLayoutMessge && (
                      <div className='message'>
                        <p>
                          <a href={`/administration/v2/index.php/product/form/${this.state.homeProductID}`}>
                            Product with ID {this.state.homeProductID}
                          </a>{' '}
                          and{' '}
                          <a
                            onClick={() => {
                              this.props.changePage('product_909210');
                            }}
                          >
                            Layout {this.state.homeProductLayout}
                          </a>{' '}
                          used for your Homepage. <br /> To use Homepage layout please unset Product from{' '}
                          <a href={`/administration/v2/index.php/product/form/${this.state.homeProductID}`}>
                            Product Edit page
                          </a>
                        </p>
                      </div>
                    )}
                    {this.state.showProductLayoutWarning && (
                      <div className='warning'>
                        <Icons
                          icon='time'
                          onClick={() => {
                            this.setState({ showProductLayoutWarning: null });
                          }}
                        />
                        <p>
                          No Product/Product layout is set for <b>HOMEPAGE</b>
                        </p>
                      </div>
                    )}
                  </div>
                )}

                <Tour
                  steps={this.guideSteps}
                  isOpen={this.state.showTour}
                  onRequestClose={() => this.setState({ showTour: false })}
                  rounded={5}
                  helperWidth={300}
                />

                <div className={`middle-side ${this.props.currentPage}`}>
                  <div
                    className={`preview ${this.props.currentDevice} ${
                      this.props.currentDevice == 'custom' ? 'xl' : ''
                    }`}
                  >
                    <div className='window-bar'>
                      <div></div>
                      <div></div>
                      <div></div>
                      {/* <p>
                        This is the beta release of updated builder. Please
                        reach support If you noticed any issue. Groovekart
                        support will be glad to help.
                      </p> */}
                    </div>

                    <div
                      className={`window-content ${this.state.activeTab === 1 ? 'visible' : 'hidden'} ${
                        this.state.changingPayload ? 'no-flow' : ''
                      }`}
                      data-step='3'
                    >
                      {this.state.changingPayload && <Loader color={2} />}
                      <div className='droptoscreen'>
                        {!this.state.savingScreenshot &&
                          this.props.currentPage !== 'flyoutcart' &&
                          this.props.currentPage !== 'top_bar' &&
                          this.props.currentPage !== 'footer' && (
                            <HeaderFooter
                              element='top_bar'
                              editLayout={() => {
                                this.props.changePage('top_bar');
                              }}
                            />
                          )}

                        {!this.state.savingScreenshot &&
                          this.props.currentPage !== 'flyoutcart' &&
                          this.props.currentPage !== 'top_bar' &&
                          this.props.currentPage !== 'footer' && (
                            <HeaderFooter
                              element='header'
                              // onToggle={this._toggleDialog}
                              editFloatCart={() => {
                                this.props.changePage('flyoutcart');
                              }}
                            />
                          )}

                        <div
                          className={`canvas-area ${this.props.currentPage.includes('modal_') ? 'modal-canvas' : ''}`}
                        >
                          <div className='screenme' style={this.state.pageBackground}>
                            <Canvas
                              onDrop={this._onDrop}
                              initialElements={this.state.initialElements}
                              placeholder={l('Drop Here')}
                              currentPage={this.props.currentPage}
                              version={this.state.frameVersion}
                            />
                          </div>
                        </div>

                        {!this.state.savingScreenshot && this.props.currentPage === 'top_bar' && (
                          <HeaderFooter
                            element='header'
                            editFloatCart={() => {
                              this.props.changePage('flyoutcart');
                            }}
                          />
                        )}

                        {!this.state.savingScreenshot &&
                          !this.state.changingPayload &&
                          this.props.currentPage !== 'flyoutcart' &&
                          this.props.currentPage !== 'top_bar' &&
                          this.props.currentPage !== 'footer' && (
                            <HeaderFooter
                              element='footer'
                              editLayout={() => {
                                this.props.changePage('footer');
                              }}
                            />
                          )}
                      </div>
                    </div>

                    {this.devMode && (
                      <div className={`window-content ${this.state.activeTab === 3 ? 'visible' : 'hidden'}`}>
                        <ReactJson src={this.state.currentState} collapsed theme='solarized' />
                      </div>
                    )}

                    <div className='window-footer'>
                      <div className='element-breadcrumb'>{this._breadcrumbGenerator()}</div>
                    </div>
                  </div>
                </div>

                <div className='right-side'>
                  {/* <HeaderSetting /> */}

                  {this.props?.elementToEdit === 'appearance' ? (
                    <ThemeAppearance editElement={this.props.editElement} currentTab={1} />
                  ) : this.props?.elementToEdit === 'header' ? (
                    <ThemeAppearance editElement={this.props.editElement} currentTab={2} />
                  ) : null}
                  <BlockSettings />
                </div>
              </div>
            )}
          </div>
          {/* New settings for elements (floating) */}
          <FloatElementSettings open={this.props.openFloatElementSettings} />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  fetchPages,
  editElement,
  fetchPayloads,
  setPayload,
  clearHistory,
  setHistorying,
  updatePayloadHistory,
  fetchProducts,
  fetchCategories,
  fetchMenu,
  fetchThemes,
  fetchLangs,
  getTranslations,
  changePage,
  savePage,
  changeDevice,
  copyIt,
  getStoreLogo,
  fetchTemplates,
  setShowBlockSettings,
  selectedTheme,
  setGlobalList,
})(App);
